module.exports = __webpack_public_path__ + "static/media/cap4-02-mob.5c6fc1e6.png";